
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


export default {
data() {
return {
selected: 0
};
},
props: ["tabs", "active"],
methods: {
onItemClick(e) {
this.selected = e;
this.$emit("on-tab-click", e);
}
},
watch: {
active: function(e) {
this.selected = e;
}
},
components: {
Tab,
TabItem
}
};



// WEBPACK FOOTER //
// ./src/components/CTab.vue